<template>
    <div class="qksm qksm4 page">
        <h4>四、关于{{$store.state.divData.divname}}2022年财政拨款收支预算情况的总体说明</h4>
        <div class="nogap">
            <p>
                {{$store.state.divData.divname}}2022年财政拨款收支总预算{{isMoney(T4.总计)}}万元，
                <span class="hide_pdf">
                    （去年预算数<reason type="money" classname="qksm money" name="T4总计last" v-model:value="T4['总计last']"></reason>万元）
                </span>
                <span v-if="T4.总计==num(T4.总计last)">
                    与上年相同。
                </span>
                <span v-else>
                    比上年{{growthValueText(T4.总计, num(T4.总计last))}}万元，
                    <span v-if="num(T4.总计last)==0">
                        去年无预算。
                    </span>
                    主要是<reason type="textarea" classname="qksm widest" name="T4原因" v-model:value="qksm['T4原因']"></reason>
                </span>
                收入包括：
                一般公共预算当年拨款收入{{isMoney(T4.收入[0])}}万元，上年结转{{isMoney(T4.收入[1])}}万元；
                政府性基金预算当年拨款收入{{isMoney(T4.收入[2])}}万元，上年结转{{isMoney(T4.收入[3])}}万元。
                支出包括：
                <span v-for="(item, idx) in T4.支出">
                    {{item.name.replace("支出", "")}}支出{{isMoney(item.value)}}万元{{idx==T4.支出.length-1?'。':'；'}}
                </span>
            </p>
        </div>
        <div id="myChart4" class="echart" v-if="(!isPdf && $parent.isData) || isPdf"></div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm4",
        data() {
            var qksm = this.$store.state.divData.qksm;
            if (qksm['T4总计last'])
                this.T4['总计last'] = qksm['T4总计last'];
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm
            }
        },
        props: {
            T4: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
    };
</script>
